/* eslint-disable @typescript-eslint/no-explicit-any */
// 2) Third-party library imports
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash-es';

// 3a) Constants
import { API_NAME } from '../../config/config';

// 3c) Project-specific modules - components
import { _queries as queries } from '../../graphql/queries.graphql';

// 3d) Utility functions
import { DynamicObject } from '../../utils/commonInterfaces';
import client, { post } from 'src/api';

// 3e) Redux actions & types
import { BankFileCustomization } from './types';
import {
    getBankFileAction,
    getBankFileSuccessAction,
    saveBankFileRequestAction,
    saveBankFileResponseAction,
} from './bankSlice';
import { setLoadingCompanyAction } from '../companies/actions';

/**
 * Function called for saving the bank-file - talking to the API.
 */
function* handleSaveBankFileRequest({ payload: sagaPayload }: any) {
    const { payload, callback } = sagaPayload;
    
    try {
        yield call(post, {
            apiName: API_NAME, 
            path: '/bank-file-configuration/save', 
            options: {
                body: payload,
            }
        });

        yield put(saveBankFileResponseAction());

        if (callback) {
            const response = {
                IsSuccess: true,
            };

            callback(response);
        }
        // calls for queries if needed
    } catch (err) {
        if (callback) {
            let returnData: any;
        
            if (err instanceof Error && 'response' in err && (err as any).response.body) {
                returnData = JSON.parse((err as any).response.body);
            } else if (err instanceof Error) {
                returnData = { Messages: [err.message] };
            } else {
                returnData = { Messages: ['An unknown error occurred.'] };
            }
            returnData.IsSuccess = false;
            callback(returnData);
        }
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.');
        }
        yield put(saveBankFileResponseAction());
    }
}

/**
 * Function responsible for getting the company workflow names.
 */
function* handleGetBankFileRequest() {
    try {
        yield put(setLoadingCompanyAction(true));
        const res: DynamicObject = yield call(
            [client, 'graphql'],
            {
                query: queries.GET_BANK_FILE_CONFIGURATION_FOR_COMPANY
            }
        );

        const bankFileCustomization: BankFileCustomization = get(
            res,
            'data.GetBankFileConfigurationForCompany'
        );
        yield put(getBankFileSuccessAction(bankFileCustomization));
        yield put(setLoadingCompanyAction(false));
    } catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.', err);
        }
        yield put(getBankFileSuccessAction(undefined)); // Empty if error
        yield put(setLoadingCompanyAction(false));
    }
}

function* watchSaveBankFileRequest() {
    yield takeLatest(
        saveBankFileRequestAction.type,
        handleSaveBankFileRequest
    );
}

function* watchGetBankFileRequest() {
    yield takeLatest(
        getBankFileAction.type,
        handleGetBankFileRequest
    );
}

function* banksSaga() {
    yield all([
        fork(watchSaveBankFileRequest),
        fork(watchGetBankFileRequest),
    ]);
}

export default banksSaga;